// Mock data for Redtop Contracting & Consulting website

export const services = [
  {
    id: 'kitchen',
    name: 'Kitchen Remodels',
    description: 'Transform your kitchen into a modern, functional space with custom cabinetry, countertops, and appliances.',
    icon: 'ChefHat',
    image: '/gallery-photos/kitchen-featured.jpg'
  },
  {
    id: 'bathroom',
    name: 'Bathroom Remodels',
    description: 'Create a luxurious bathroom retreat with elegant fixtures, tile work, and custom vanities.',
    icon: 'Bath',
    image: '/gallery-photos/bathroom-blue-tile-1.png'
  },
  {
    id: 'flooring',
    name: 'Flooring',
    description: 'Quality flooring installation including hardwood, tile, laminate, and luxury vinyl.',
    icon: 'Layers',
    image: '/gallery-photos/flooring-entrance-1.jpg'
  },
  {
    id: 'windows-doors',
    name: 'Windows & Doors',
    description: 'Energy-efficient window and door installation to enhance your home\'s comfort and curb appeal.',
    icon: 'DoorOpen',
    image: '/gallery-photos/dutch-door-1.jpg'
  },
  {
    id: 'carpentry-decks',
    name: 'Carpentry & Decks',
    description: 'Expert carpentry services and custom deck construction for outdoor living spaces.',
    icon: 'Hammer',
    image: '/gallery-photos/mixed-60.jpg'
  },
  {
    id: 'painting-trim',
    name: 'Painting & Trim Work',
    description: 'Professional interior and exterior painting with meticulous trim and finish work.',
    icon: 'Paintbrush',
    image: '/gallery-photos/mixed-40.jpg'
  },
  {
    id: 'upgrades',
    name: 'Interior & Exterior Upgrades',
    description: 'Comprehensive home improvements to enhance aesthetics, functionality, and value.',
    icon: 'Home',
    image: '/gallery-photos/mixed-32.jpg'
  },
  {
    id: 'full-renovation',
    name: 'Full Home Renovations',
    description: 'Complete home transformation from concept to completion with expert project management.',
    icon: 'Building2',
    image: '/gallery-photos/kitchen-main-2.jpg'
  }
];

export const galleryImages = {
  kitchen: [
    { id: 1, url: '/gallery-photos/kitchen-featured.jpg', title: 'Modern Gray Kitchen with Quartz Countertops - Redtop Contracting' },
    { id: 2, url: '/gallery-photos/kitchen-main-1.jpg', title: 'Modern White Kitchen with Island - Redtop Contracting' },
    { id: 3, url: '/gallery-photos/kitchen-main-2.jpg', title: 'Elegant Kitchen with Marble Countertops - Redtop Contracting' },
    { id: 4, url: '/gallery-photos/kitchen-new-5.jpg', title: 'Stylish Kitchen Upgrade - Redtop Contracting' },
    { id: 5, url: '/gallery-photos/kitchen-new-10.jpg', title: 'Complete Kitchen Remodel - Redtop Contracting' },
    { id: 6, url: '/gallery-photos/kitchen-new-15.jpg', title: 'Kitchen Transformation - Redtop Contracting' },
    { id: 7, url: '/gallery-photos/kitchen-new-20.jpg', title: 'Stunning Kitchen Renovation - Redtop Contracting' },
    { id: 8, url: '/gallery-photos/kitchen-new-1.jpg', title: 'Modern Kitchen Renovation - Redtop Contracting' },
    { id: 9, url: '/gallery-photos/kitchen-new-2.jpg', title: 'Contemporary Kitchen Design - Redtop Contracting' },
    { id: 10, url: '/gallery-photos/kitchen-new-3.jpg', title: 'Custom Kitchen Cabinetry - Redtop Contracting' },
    { id: 11, url: '/gallery-photos/kitchen-new-4.jpg', title: 'Elegant Kitchen Remodel - Redtop Contracting' },
    { id: 12, url: '/gallery-photos/kitchen-new-6.jpg', title: 'Luxury Kitchen Transformation - Redtop Contracting' },
    { id: 13, url: '/gallery-photos/kitchen-new-7.jpg', title: 'Kitchen with Custom Island - Redtop Contracting' },
    { id: 14, url: '/gallery-photos/kitchen-new-8.jpg', title: 'Professional Kitchen Renovation - Redtop Contracting' },
    { id: 15, url: '/gallery-photos/kitchen-new-9.jpg', title: 'Modern Kitchen Layout - Redtop Contracting' },
    { id: 16, url: '/gallery-photos/kitchen-new-11.jpg', title: 'Sophisticated Kitchen Design - Redtop Contracting' },
    { id: 17, url: '/gallery-photos/kitchen-new-12.jpg', title: 'Kitchen Renovation Project - Redtop Contracting' },
    { id: 18, url: '/gallery-photos/kitchen-new-13.jpg', title: 'Beautiful Kitchen Update - Redtop Contracting' },
    { id: 19, url: '/gallery-photos/kitchen-new-14.jpg', title: 'Custom Kitchen Build - Redtop Contracting' },
    { id: 20, url: '/gallery-photos/kitchen-new-16.jpg', title: 'Modern Kitchen Features - Redtop Contracting' },
    { id: 21, url: '/gallery-photos/kitchen-new-17.jpg', title: 'Quality Kitchen Work - Redtop Contracting' },
    { id: 22, url: '/gallery-photos/kitchen-new-18.jpg', title: 'Kitchen Remodeling Excellence - Redtop Contracting' },
    { id: 23, url: '/gallery-photos/kitchen-new-19.jpg', title: 'Premium Kitchen Design - Redtop Contracting' }
  ],
  bathroom: [
    { id: 1, url: '/gallery-photos/before-after-bathroom.jpg', title: 'Bathroom Gut & Remodel - Before/After - Redtop Contracting' },
    { id: 2, url: '/gallery-photos/mixed-50.jpg', title: 'Modern Shower with Marble Tiles - Redtop Contracting' },
    { id: 3, url: '/gallery-photos/mixed-51.jpg', title: 'Bathroom Vanity & Fixtures Upgrade - Redtop Contracting' },
    { id: 4, url: '/gallery-photos/bathroom-blue-tile-1.png', title: 'Luxury Bathroom with Blue Mosaic Tile - Redtop Contracting' },
    { id: 5, url: '/gallery-photos/bathroom-album-1.jpg', title: 'Modern Bathroom Renovation - Redtop Contracting' },
    { id: 6, url: '/gallery-photos/bathroom-album-2.jpg', title: 'Contemporary Bathroom Design - Redtop Contracting' },
    { id: 7, url: '/gallery-photos/bathroom-album-3.jpg', title: 'Elegant Bathroom Remodel - Redtop Contracting' },
    { id: 8, url: '/gallery-photos/bathroom-album-4.jpg', title: 'Custom Bathroom with Modern Fixtures - Redtop Contracting' },
    { id: 9, url: '/gallery-photos/bathroom-album-5.jpg', title: 'Bathroom Renovation Project - Redtop Contracting' },
    { id: 10, url: '/gallery-photos/bathroom-album-6.jpg', title: 'Professional Bathroom Remodel - Redtop Contracting' },
    { id: 11, url: '/gallery-photos/bathroom-album-7.jpg', title: 'Luxurious Bathroom Upgrade - Redtop Contracting' },
    { id: 12, url: '/gallery-photos/bathroom-album-8.jpg', title: 'Complete Bathroom Transformation - Redtop Contracting' }
  ],
  flooring: [
    { id: 1, url: '/gallery-photos/mixed-52.jpg', title: 'Hardwood Floor Installation - Redtop Contracting' },
    { id: 2, url: '/gallery-photos/mixed-53.jpg', title: 'Living Room Hardwood Flooring - Redtop Contracting' },
    { id: 3, url: '/gallery-photos/flooring-entrance-1.jpg', title: 'Tile Flooring Installation - Redtop Contracting' },
    { id: 4, url: '/gallery-photos/flooring-entrance-2.jpg', title: 'Professional Flooring Work - Redtop Contracting' }
  ],
  'windows-doors': [
    { id: 1, url: '/gallery-photos/dutch-door-1.jpg', title: 'Custom Turquoise Dutch Door - Redtop Contracting' },
    { id: 2, url: '/gallery-photos/dutch-door-2.jpg', title: 'Dutch Door Open Top - Stone Exterior - Redtop Contracting' },
    { id: 3, url: '/gallery-photos/dutch-door-3.jpg', title: 'Dutch Door Full Open Entry - Redtop Contracting' },
    { id: 4, url: '/gallery-photos/mudroom-builtins-1.jpg', title: 'Blue Farmhouse Mudroom Built-ins with Ladder - Redtop Contracting' },
    { id: 5, url: '/gallery-photos/mudroom-builtins-2.jpg', title: 'Blue Farmhouse Entryway Shelving & Cabinetry - Redtop Contracting' },
    { id: 6, url: '/gallery-photos/mixed-31.jpg', title: 'Front Entry Door System - Redtop Contracting' },
    { id: 7, url: '/gallery-photos/mixed-45.jpg', title: 'Exterior Window Upgrade - Redtop Contracting' },
    { id: 8, url: '/gallery-photos/mixed-34.jpg', title: 'New Window Delivery & Installation - Redtop Contracting' },
    { id: 9, url: '/gallery-photos/windows-doors-1.jpg', title: 'Professional Door Installation - Redtop Contracting' },
    { id: 10, url: '/gallery-photos/windows-doors-2.jpg', title: 'Exterior Door Replacement - Redtop Contracting' },
    { id: 11, url: '/gallery-photos/windows-doors-3.jpg', title: 'Modern Window Installation - Redtop Contracting' },
    { id: 12, url: '/gallery-photos/windows-doors-4.jpg', title: 'Custom Door Project - Redtop Contracting' },
    { id: 13, url: '/gallery-photos/windows-doors-5.jpg', title: 'Energy-Efficient Window Work - Redtop Contracting' },
    { id: 14, url: '/gallery-photos/windows-doors-6.jpg', title: 'Door Frame Installation - Redtop Contracting' },
    { id: 15, url: '/gallery-photos/windows-doors-7.jpg', title: 'Window and Door Renovation - Redtop Contracting' },
    { id: 16, url: '/gallery-photos/windows-doors-8.jpg', title: 'Entry Door Upgrade - Redtop Contracting' },
    { id: 17, url: '/gallery-photos/windows-doors-9.jpg', title: 'Professional Window Replacement - Redtop Contracting' },
    { id: 18, url: '/gallery-photos/windows-doors-10.jpg', title: 'Complete Door System Installation - Redtop Contracting' },
    { id: 19, url: '/gallery-photos/mixed-46.jpg', title: 'Window Replacement Project - Redtop Contracting' }
  ],
  'carpentry-decks': [
    { id: 1, url: '/gallery-photos/before-after-closet.jpg', title: 'Closet Expansion & Ceiling Access Ladder - Before/After - Redtop Contracting' },
    { id: 2, url: '/gallery-photos/mixed-60.jpg', title: 'Elevated Deck with Stairs - Redtop Contracting' },
    { id: 3, url: '/gallery-photos/mixed-38.jpg', title: 'Modern Deck with Railings - Redtop Contracting' },
    { id: 4, url: '/gallery-photos/mixed-39.jpg', title: 'Deck & Lattice Skirting - Redtop Contracting' },
    { id: 5, url: '/gallery-photos/mixed-55.jpg', title: 'Staircase Renovation with Iron Railings - Redtop Contracting' },
    { id: 6, url: '/gallery-photos/carpentry-stairs-1.jpg', title: 'Custom Staircase & Trim Work - Redtop Contracting' },
    { id: 7, url: '/gallery-photos/carpentry-stairs-2.jpg', title: 'Finished Carpentry & Railings - Redtop Contracting' },
    { id: 8, url: '/gallery-photos/mixed-33.jpg', title: 'Porch Carpentry & Renovation - Redtop Contracting' },
    { id: 9, url: '/gallery-photos/mixed-35.jpg', title: 'Outdoor Storage Shed Construction - Redtop Contracting' }
  ],
  'painting-trim': [
    { id: 1, url: '/gallery-photos/mixed-56.jpg', title: 'Hallway & Staircase Painting - Redtop Contracting' },
    { id: 2, url: '/gallery-photos/mixed-40.jpg', title: 'Interior Room Painting - Redtop Contracting' }
  ],
  upgrades: [
    { id: 1, url: '/gallery-photos/project-video-1.mp4', title: 'Project Showcase Video - Redtop Contracting' },
    { id: 2, url: '/gallery-photos/mixed-32.jpg', title: 'Modern Home Exterior Upgrade - Redtop Contracting' },
    { id: 3, url: '/gallery-photos/mixed-57.jpg', title: 'Fireplace & Living Room Update - Redtop Contracting' },
    { id: 4, url: '/gallery-photos/mixed-37.jpg', title: 'Front Entrance Steps & Walkway - Redtop Contracting' },
    { id: 5, url: '/gallery-photos/mixed-36.jpg', title: 'Patio Pressure Washing Service - Redtop Contracting' },
    { id: 6, url: '/gallery-photos/mixed-41.jpg', title: 'Interior Hallway Renovation - Redtop Contracting' },
    { id: 7, url: '/gallery-photos/mixed-58.jpg', title: 'Fireplace Modernization Project - Redtop Contracting' }
  ],
  'full-renovation': [
    { id: 1, url: '/gallery-photos/before-after-storm-reno.jpg', title: 'Storm Damage Gut & Renovation with New Windows - Before/After - Redtop Contracting' },
    { id: 2, url: '/gallery-photos/mixed-52.jpg', title: 'Open Concept Living Space - Redtop Contracting' },
    { id: 3, url: '/gallery-photos/kitchen-main-1.jpg', title: 'Complete Kitchen Renovation - Redtop Contracting' },
    { id: 4, url: '/gallery-photos/kitchen-main-2.jpg', title: 'Full Kitchen Remodel - Redtop Contracting' }
  ]
};

export const testimonials = [
  {
    id: 1,
    name: 'Sarah Mitchell',
    project: 'Kitchen Remodel',
    rating: 5,
    text: 'Redtop transformed our outdated kitchen into a stunning modern space. Their attention to detail and professionalism exceeded our expectations.'
  },
  {
    id: 2,
    name: 'John Davis',
    project: 'Full Home Renovation',
    rating: 5,
    text: 'From start to finish, the team was incredible. They managed our entire home renovation seamlessly and the results are absolutely beautiful.'
  },
  {
    id: 3,
    name: 'Emily Rodriguez',
    project: 'Bathroom Remodel',
    rating: 5,
    text: 'Outstanding craftsmanship and excellent communication throughout the project. Our bathroom looks like something out of a magazine!'
  }
];

export const projectTypes = [
  'Kitchen Remodel',
  'Bathroom Remodel',
  'Flooring',
  'Windows & Doors',
  'Carpentry & Decks',
  'Painting & Trim Work',
  'Interior & Exterior Upgrades',
  'Full Home Renovation'
];

export const budgetRanges = [
  'Under $10,000',
  '$10,000 - $25,000',
  '$25,000 - $50,000',
  '$50,000 - $100,000',
  '$100,000+'
];

export const timelines = [
  'Immediately',
  'Within 1-3 months',
  'Within 3-6 months',
  'Within 6-12 months',
  'Planning phase'
];